export default require('pretty-ms')